import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerShipmentsList } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { ship_status_text } from "../Orders/ShipmentDetails";

const PendingActions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const orders = useSelector((state) => state?.shipNPay?.customer_shipments_list);

  useEffect(() => {
    dispatch(
      customerShipmentsList({
        email: localStorage.getItem("email"),
      })
    );
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      header: "Shipment ID",
      accessor: "ShipNo",
      width: 20,
    },
    {
      header: "Sales Order",
      accessor: "SoNumber",
      width: 20,
      cell: (row) => (
        <span className="error-text">
          {row.SoNumber ? row.SoNumber : "-"}
        </span>
      ),
    },
    {
      header: "Customer PO",
      width: 20,
      accessor: "Bstnk",
      cell: (row) => <span className="error-text">{row.Bstnk}</span>,
    },
    {
      header: "Quantity Ordered",
      accessor: "Kwmeng",
      width: 20,
      cell: (row) => <span>{parseInt(row.Kwmeng)}</span>,
    },
    {
      header: "Shipment Status",
      accessor: "ShipStatus",
      width: 20,
      cell: (row) => (
        <span className="success-text">{ship_status_text[row.ShipStatus]}</span>
      ),
    },

  ];
  return (
    <div className="tb1">
      <div className="flex-between mb1">
        <label>Pending Actions</label>
        <span
          className="cursor view-all"
          onClick={() => {
            history.push("/track-shipments");
          }}
        >
          VIEW ALL
        </span>
      </div>
      <div>
        <Table
          columns={columns}
          style={{ margin: 0 }}
          data={
            orders && Array.isArray(orders?.data)
              ? orders?.data?.filter(
                // eslint-disable-next-line
                (ele) => ele?.Preshipstatus === "P" && ele?.ShipNo &&  (ele?.ShipStatus == 1 || ele?.ShipStatus == 0 || ele?.ShipStatus == 2 || ele?.ShipStatus == 3 || ele?.ShipStatus == 4 || ele?.ShipStatus == 6)
              )?.slice(0, 5)
              : []
          }
          loading={orders?.loading}
          onRowClick={(val) => {
            history.push("/shipment-detail", {
              do_number: val.DeliveryNo,
              shipment_no: val.ShipNo,
            });
          }}
        />
      </div>
    </div>
  );
};

export default PendingActions;
